import React, { useContext } from "react";
import BackspaceIcon from "@mui/icons-material/Backspace";

import SocketIOContext from "../../../../contexts/Kiosk/SocketProvider/SocketIOContext";

export default function BackspaceButton(props) {
  const { show, onClick } = props;
  const { getKioskTheme } = useContext(SocketIOContext);
  const kiosktheme = getKioskTheme();

  if (!show) {
    return <div></div>;
  }

  return (
    <div style={{ display: "block", marginTop: "auto", marginBottom: "auto" }}>
      <BackspaceIcon
        style={{
          marginLeft: "3.2vw",
          fontSize: "5.5vh",
          color: kiosktheme.buttonsBGColor
        }}
        onClick={onClick}
      />
    </div>
  );
}
